module.exports = __webpack_public_path__ + "img/12.14d88f24.png";